import Immutable, { List, Map } from 'immutable';
import { denormalize } from 'normalizr';

import { tagListSchema } from '../../schemas/tag';

const FIXED_TYPES = ['organization', 'campusDirector'];

const getTypeRank = (type) => {
  const rank = FIXED_TYPES.indexOf(type);
  return rank === -1 ? FIXED_TYPES.length : rank;
};

export default function getTags(state) {
  const tag = state.get('tag');
  const currentChapter = state.get('currentChapter');

  const result = currentChapter.getIn(['data', 'tags'], List());
  const tags = tag.getIn(['data', 'items'], Map());
  let items = [];

  if (result.size > 0) {
    const entities = {
      tag: tags.toJS(),
    };

    items = denormalize(result.toJS(), tagListSchema, entities);

    items = items
      .map(item => (
        FIXED_TYPES.includes(item.type)
          ? { ...item, draggable: false }
          : item
      ))
      .sort((a, b) => getTypeRank(a.type) - getTypeRank(b.type));
  }

  return Immutable.fromJS(items);
}
